<template>
  <v-row class="justify-center">
    <v-col cols="12" md="4">
      <v-alert dismissible type="error">
        <h3 class="headline-1">
          Não foi possível processar as seguintes multas
        </h3>
        <p v-for="(item, key) in items" :key="key">
          {{ item }}
        </p>
      </v-alert>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "Alert",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>